import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'

import Button from '@shared/ui/button'

import styles from './CancelOrderModal.module.scss'

type CancelOrderModalProps = {
  onConfirm: () => void
}

export default function CancelOrderModal ({ onConfirm }: CancelOrderModalProps) {
  const { t: to } = useTranslation('order')
  const { closeAllModals } = useModalStore()

  const handleConfirm = () => {
    onConfirm()
    closeAllModals()
  }

  return (
    <div className={styles.root}>
      <p className={styles.root__text}>{to('order.cancel.confirm')}</p>
      <div className={styles.root__buttons}>
        <Button
          className={styles.root__cancelButton}
          onClick={closeAllModals}
          theme="grey"
          size="large"
        >
          {to('order.cancel.no')}
        </Button>
        <Button
          className={styles.root__confirmButton}
          onClick={handleConfirm}
          theme="primary"
          size="large"
        >
          {to('order.cancel.yes')}
        </Button>
      </div>
    </div>
  )
}
